import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/ui/Button';
import TextInput from '../../components/forms/TextInput';
import { useNavigate } from 'react-router';
import { registerLecturer } from '../../services/registerService';
import { useAuth } from '../../contexts/authContext';
import { toast } from 'sonner';
import AlertBox from '../../components/ui/AlertBox';
import UniversitySelectInput from '../../components/forms/UniversitySelectInput';
import { useRedirectParam } from '../../hooks/useRedirectParam';

function LecturerSignupPage() {
  let navigate = useNavigate();
  const { consumeRedirect } = useRedirectParam();
  let { register, watch, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm();
  let { user, setUser, setProfile } = useAuth();

  let [pageError, setPageError] = useState();

  const onSubmit = async (data) => {
    console.log('Form data:', data);
    try {
      let dataToSend = {
        ...(data.university !== 'other' ? {university: data.university} : {}),
        ...(data.other_university ? {other_university: data.other_university} : {}),
      }
      console.log('Data to send:', dataToSend);
      
      const response = await registerLecturer(dataToSend);
      console.log('Registration successful:', response);

      // Guard against wiping auth state if API response has no user field
      if (response.user) {
        setUser(response.user);
      } else {
        setUser((prev) => prev ? { ...prev, is_profile_complete: true, user_type: 'lecturer' } : prev);
      }
      setProfile(response);

      // raise alert
      toast.success('Successfully Completed your profile')

      const storedRedirect = consumeRedirect();
      if (storedRedirect) {
        navigate(storedRedirect, { replace: true });
      } else {
        navigate('/lecturer/dashboard', { replace: true });
      }
    } catch (error) {
      console.error('Registration failed:', error);
      if (error && typeof error === 'object') {
        if (error.detail) {
          setPageError(error.detail);
        } else {
          Object.keys(error).forEach((field) => {
            const getErrorMessage = (val) => Array.isArray(val) ? val[0] : val;
            
            if (field === 'non_field_errors') {
              setPageError(getErrorMessage(error[field]));
            } else if (field === 'user' && error.user && typeof error.user === 'object') {
              Object.keys(error.user).forEach((userField) => {
                setError(userField, { type: 'server', message: getErrorMessage(error.user[userField]) });
              });
            } else {
              setError(field, { type: 'server', message: getErrorMessage(error[field]) });
            }
          });
        }
      } else {
        setPageError('An unexpected error occurred during signup.');
      }
    }
  }

  return (
    <div className='bg-base-200 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-2xl mx-auto'>
        {/* greeting section */}
        <div className="text-center space-y-4 mb-8">
          <div className="flex items-center justify-center gap-2 text-xl font-medium">
            <span>Hey,</span>
            <span className="font-bold">{user.first_name}</span>
            <span className="animate-wave text-3xl">👋</span>
          </div>

          <h1 className="text-4xl font-extrabold tracking-tight">
            Complete Your{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-pink-500 to-orange-500">
              Lecturer
            </span>{" "}
            Profile
          </h1>
        </div>

        <div className="bg-base-100 shadow-xl rounded-box p-8">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 gap-6">
              <div>
                <AlertBox message={pageError} type='error' />

                <UniversitySelectInput 
                  register={register}
                  errors={errors}
                  name="university"
                  validationRules={{ required: 'University is required' }}
                  withOtheroption={true}
                />

                {watch('university') === 'other' && (
                  <TextInput
                    label="University Name"
                    name="other_university"
                    register={register}
                    errors={errors}
                    validationRules={{ required: 'University name is required' }}
                  />
                )}

              </div>
            </div>
            <Button
              className='w-full mt-4'
              isLoading={isSubmitting}
            >
              Create Account
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LecturerSignupPage